<template lang="pug">
  .user-notifications
    DropdownMenu(type="header")
      template(slot="toggle")
        .notification-icon
          .notification-icon-center
            font-awesome-icon.icon(:icon="['fas', 'bell']")
      template(slot="menu")
        .notification-items
          .notification-item(v-for="notification in availableNotifications")
            component(:is="notificationMapper[notification.action]", :notification="notification", :key="notification._id")
          .empty-state(v-if="notifications.length === 0")
            p No Notifications
</template>

<script>

import { mapState } from 'vuex'

import { NotificationComment, NotificationStatusChange, NotificationAssigned, NotificationLinked } from '@/components/notifications'

const notificationMapper = {
  commented: 'NotificationComment',
  status_changed: 'NotificationStatusChange',
  assigned: 'NotificationAssigned',
  linked: 'NotificationLinked',
  unlinked: 'NotificationLinked'
}

export default {
  name: 'UserNotifications',
  components: {
    NotificationComment,
    NotificationStatusChange,
    NotificationAssigned,
    NotificationLinked
  },
  props: {
  },
  data () {
    return {
      notificationMapper
    }
  },
  computed: {
    ...mapState({
      notifications: state => state.notifications
    }),
    availableNotifications () {
      let availableNotifications = ['commented', 'status_changed', 'assigned', 'linked', 'unlinked']
      return this.notifications.filter(notification => availableNotifications.indexOf(notification.action) > -1)
    }
  },
  mounted () {
    // console.log(this.notifications)
  }
}
</script>

<style lang="stylus" scoped>
  .user-notifications
    color var(--fw-text-color, $text-default)
    +for_breakpoint(mobile)
      .dropdown
        .dropdown-menu
          left auto
          right -132px
</style>
